export const COLOR_GREEN = '#009530'; // available/scheduled border + active SmartAmp indicator
export const COLOR_GREEN_DARK = '#3DCD57'; // dark mode green accent
export const COLOR_BLUE = '#1E79B6'; // charging border
export const COLOR_BLUE_DARK = '#42B4E6'; // dark mode blue accent
export const COLOR_BLUE_DARK_DIM = 'rgba(66,180,230,0.1)'; // dims COLOR_BLUE_DARK
export const COLOR_RED = '#BA3430'; // error border
export const COLOR_GRAY = '#979797'; // offline border + inactive SmartAmp indicator
export const COLOR_AMBER = '#FFD100'; // fw update/offline/suspended indicator — matches EVSECharger COLOR_INDICATOR_FW_UPDATE/COLOR_INDICATOR_OFFLINE
export const COLOR_AMBER_DIM = 'rgba(255, 209, 0, 0.1)'; // dims COLOR_AMBER
export const COLOR_AMBER_DARK = '#FEDC38'; // dark mode amber accent
export const COLOR_AMBER_DARK_DIM = 'rgba(254, 220, 56, 0.1)'; // dims COLOR_AMBER_DARK
export const COLOR_ADD_RATES = '#1E79B6'; // Add rates link
export const COLOR_DIVIDER = '#636A75'; // column dividers
export const COLOR_TEXT = '#3A3A3C'; // primary text
export const COLOR_NUMBER = '#111111'; // numeric values and units
